module.exports = __webpack_public_path__ + "img/page-ss-monitoring.31dfd405.png";